import type { ApiRoutes, AuthPipelineRoutes } from '@tempo-io/id-app/rpc';
import { hc } from 'hono/client';
import { createHonoRpcClient } from './hono-rpc-client';

export const getIdServiceApi = createHonoRpcClient<ApiRoutes>('/api/');

export const getAuthPipelineApi = ({ prefixUrl = '' }: { prefixUrl?: string } = {}) =>
  hc<AuthPipelineRoutes>(`${prefixUrl}/auth-pipeline/`);
